import React, { Component } from 'react'

import { FormattedMessage } from 'react-intl'
import cx from 'classnames'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class DistraintsTooltip extends Component {
    render() {
        return (
            <div>
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.distraintsTooltipMain`}
                    values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                />
                <div className={cx('tooltip-distraints-icon', 'na')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.distraintsNo`} />
                </div>
                <div className={cx('tooltip-distraints-icon', 'distraints-present')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.distraintsActive`} />
                </div>
                <div className={cx('tooltip-distraints-icon', 'distraints-past')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.distraintsHistorical`} />
                </div>
                <div>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.distraintsFooter`}
                        values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                    />
                </div>
            </div>
        )
    }
}
